module.exports = __webpack_public_path__ + "img/Group 2005.15e8268c.svg";